/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

import { initClickTracking } from './src/utils/analytics';

export const onClientEntry = () => {
  initClickTracking();
};

export const onRouteUpdate = () => {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event('routechange'));
  }
};
